import { createZeroDevPaymasterClient } from '@zerodev/sdk';
import type { Hex, Chain as ViemChain } from 'viem';
import { http } from 'viem';
import type { GetPaymasterDataParameters } from 'viem/account-abstraction';

type GetPaymasterConfigProps = {
  chain: ViemChain;
  /**
   * The address the ERC20 token to use for the paymaster.
   * If not provided, the paymaster will use the default gas token for the chain.
   */
  gasTokenAddress?: Hex;
  paymasterRpc: string;
};

export const getPaymasterConfig = ({
  chain,
  gasTokenAddress,
  paymasterRpc,
}: GetPaymasterConfigProps) => {
  const getPaymasterData = (params: GetPaymasterDataParameters) => {
    const zerodevPaymaster = createZeroDevPaymasterClient({
      chain,
      transport: http(paymasterRpc),
    });

    return zerodevPaymaster.sponsorUserOperation({
      gasToken: gasTokenAddress,
      userOperation: params,
    });
  };

  return {
    paymaster: {
      getPaymasterData,
    },
  };
};
